import { memo } from 'react';

import type { RelevancyCardProps } from '../DynamicCardComponent';

const WebLinkComponent = ({ item }: RelevancyCardProps) => (
  <>
    {item.teaser?.resourceUrl && (
      <div className='card'>
        <iframe
          style={{ minHeight: item.teaser.minHeight }}
          src={item.teaser.resourceUrl.replace('http://', '//')}
          title={item.teaser.title}
        />
      </div>
    )}
  </>
);

export default memo(WebLinkComponent);
